import { render, staticRenderFns } from "./AddItemModal.vue?vue&type=template&id=3b8057f4&"
import script from "./AddItemModal.vue?vue&type=script&lang=js&"
export * from "./AddItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports